import { useCallback } from "react";
import { proxy, useSnapshot } from "valtio";
import { usePreviewContext } from "../contexts/preview-context";
import { useEditor } from "./useEditor";

const overviewModeState = proxy({
	isOverviewMode: false,
});

export function useIsOverviewMode() {
	const { selection } = useEditor();
	const { resetZoom } = usePreviewContext();

	return [
		useSnapshot(overviewModeState).isOverviewMode,
		useCallback(
			function setIsOverviewMode(value: boolean) {
				overviewModeState.isOverviewMode = value;

				// Deselect the current zone when going to overview mode
				if (value) {
					selection.setCurrentZoneAndBroadcast(undefined);
				}

				// Reset zoom when changing overview mode
				resetZoom(selection.getCurrentSpread());
			},
			[selection, resetZoom],
		),
	] as const;
}
